var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFaviconJudi = function SvgFaviconJudi(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9357C0 18.5304 5.33695 23.8732 11.9283 23.8732C18.5196 23.8732 23.8566 18.5321 23.8566 11.9357C23.8566 5.33929 18.5089 0 11.9283 0C5.34765 0 0 5.34107 0 11.9357Z",
    fill: "url(#paint0_linear_29021_6501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9287 9.97852V18.1624C14.1859 18.1624 16.0131 16.3339 16.0131 14.0749C16.0131 11.816 14.1859 9.98744 11.9287 9.98744V9.97852Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1037 14.075V18.1625H9.06064C7.92759 18.1625 7.01758 17.2429 7.01758 16.1179C7.01758 14.9929 7.93651 14.0732 9.06064 14.0732H11.1037V14.075Z",
    fill: "#A5C9EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9285 9.05218C13.654 9.05218 15.1725 9.97182 16.0129 11.3361V7.00753C16.0129 5.8736 15.094 4.96289 13.9698 4.96289C12.8457 4.96289 11.9268 5.88253 11.9268 7.00753V9.05218H11.9285Z",
    fill: "#A5C9EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29021_6501",
    x1: 0,
    y1: 11.9357,
    x2: 23.8548,
    y2: 11.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#010598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#010C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0558B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0777B9"
  })))));
};
export { SvgFaviconJudi as ReactComponent };
export default __webpack_public_path__ + "static/media/favicon-judi.7774ea17.svg";